<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <UserMenu />
      </el-col>
      <el-col v-loading="loading" :span="20">
        <div class="content-title">订单详情</div>
        <div class="section">
          <div class="section-title">订单信息</div>
          <div class="section-content">
            <el-form :model="orderInfo.baseInfo" label-width="100px" class="order-form">
              <el-row class="base-info">
                <el-col :span="12">
                  <el-form-item label="订单号">
                    <span>{{ orderInfo.baseInfo.orderNumber }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="订单日期">
                    <span>{{ orderInfo.baseInfo.orderDate | parseTime('{y}-{m}-{d}') }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="订单状态">
                    <span>{{ orderInfo.baseInfo.orderStatusName }}</span>
                    <el-button v-if="canCancel && canOperate" type="text" class="btn-inline" @click="cancelOrder()">取消订单</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="商品金额">
                    <span>￥ {{ orderInfo.baseInfo.itemAmount | toThousandslsFilter }} 元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="物流单号">
                    <span>{{ orderInfo.baseInfo.logisticsNumber }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="物流公司">
                    <span>{{ orderInfo.baseInfo.logisticsCompanyName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="orderInfo.baseInfo.isPreOrder ? (orderInfo.baseInfo.orderStatus === 50 ? '定金金额' : '尾款金额') : '订单金额'">
                    <span class="order-amount">￥ {{ showOrderAmount | toThousandslsFilter }} 元</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="orderInfo.baseInfo.couponCode" :span="12">
                  <el-form-item label="优惠卡券">
                    <span>{{ orderInfo.baseInfo.couponCode }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="orderInfo.baseInfo.ecardNumber" :span="12">
                  <el-form-item label="多利E卡">
                    <span>{{ orderInfo.baseInfo.ecardNumber }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="orderInfo.baseInfo.discountAmount > 0" :span="12">
                  <el-form-item label="抵扣金额">
                    <span>￥ {{ showDiscountAmount | toThousandslsFilter }} 元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="付款方式">
                    <span>{{ showPayInfo }}</span>
                    <router-link
                      v-if="needPay && canOperate"
                      :to="{ name: 'order-payment', params: { 'orderNumber': orderInfo.baseInfo.orderNumber }}"
                      class="pay-link"
                      target="_blank"
                      rel="opener">
                      <span v-if="orderInfo.baseInfo.orderStatus === 50">去付定金</span>
                      <span v-if="orderInfo.baseInfo.isPreOrder && orderInfo.baseInfo.orderStatus === 100">去付尾款</span>
                      <span v-if="!orderInfo.baseInfo.isPreOrder && orderInfo.baseInfo.orderStatus === 100">去付款</span>
                    </router-link>
                  </el-form-item>
                </el-col>
                <el-col v-if="orderInfo.baseInfo.isPreOrder" :span="12">
                  <el-form-item label="尾款金额">
                    <span class="order-amount">￥ {{ orderInfo.baseInfo.orderAmount | toThousandslsFilter }} 元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="已支付金额">
                    <span class="order-amount">￥ {{ orderInfo.baseInfo.paidAmount | toThousandslsFilter }} 元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="配送方式">
                    <span>{{ orderInfo.baseInfo.deliveryTypeName }}</span>
                    <!-- <el-button v-if="!hasSubOrder && hasMainLogistics" type="text" class="btn-inline" @click="viewLogisticsInfo(orderInfo.baseInfo)">
                      物流详情
                    </el-button> -->
                  <!-- <el-button type="text" @click="viewLogisticsInfo(orderInfo.baseInfo)">物流详情</el-button> -->
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder" :span="12">
                  <el-form-item label="收货码">
                    <span>{{ orderInfo.baseInfo.receiptCode }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="订单创建人">
                    <span>{{ orderInfo.baseInfo.clientName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item v-if="showLogisticsTrack == '1' " label="物流进度">
                    <el-button type="text" class="btn-watch-info" @click="watchLogisticsInfo()">查看物流详情</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="订单备注">
                    <span>{{ orderInfo.baseInfo.orderRemark }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="section">
          <div class="section-title">收货信息</div>
          <div class="section-content">
            <el-form :model="orderInfo.orderRecvInfo" label-width="124px" class="order-form" style="margin-left: -24px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="联系人">
                    <span>{{ orderInfo.orderRecvInfo.recvPerson }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <span>{{ maskMobileNo }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="收货地址">
                    <span>{{ combineAddressInfo }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder" :span="12">
                  <el-form-item label="售点编码">
                    <span>{{ orderInfo.orderRecvInfo.sfaCode }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder" :span="12">
                  <el-form-item label="售点名称">
                    <span>{{ orderInfo.orderRecvInfo.sfaAddressName }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder" :span="12">
                  <el-form-item label="售点地址">
                    <span>{{ orderInfo.orderRecvInfo.sfaAddress }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder || isPackageOrder" :span="12">
                  <el-form-item label="所属BU">
                    <span>{{ orderInfo.orderRecvInfo.sfaBuName }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAssetOrder || isPackageOrder" :span="12">
                  <el-form-item label="所属区域">
                    <span>{{ orderInfo.orderRecvInfo.sfaRegionName }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="orderInfo.baseInfo.isIcebox" :span="12">
                  <el-form-item label="是否需要搬运上楼">
                    <span>{{ orderInfo.baseInfo.upstairsFlag ? '是' : '否' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div v-if="!isAssetOrder" class="section">
          <div class="section-title">开票信息</div>
          <div class="section-content">
            <el-form :model="orderInfo.orderRecvInfo" label-width="100px" class="order-form">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开票类型">
                    <span>{{ invoiceTypeName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开票抬头">
                    <span>{{ orderInfo.orderRecvInfo.invoiceTitle }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="纳税人识别号">
                    <span>{{ orderInfo.orderRecvInfo.vatCode }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isVatInvoice" :span="12">
                  <el-form-item label="公司地址">
                    <span>{{ orderInfo.orderRecvInfo.regAddress }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isVatInvoice" :span="12">
                  <el-form-item label="公司电话">
                    <span>{{ orderInfo.orderRecvInfo.regTelephone }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isVatInvoice" :span="12">
                  <el-form-item label="开户银行">
                    <span>{{ orderInfo.orderRecvInfo.bankName }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isVatInvoice" :span="12">
                  <el-form-item label="银行账号">
                    <span>{{ orderInfo.orderRecvInfo.bankAccountId }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="isVatInvoice" :span="12">
                  <el-form-item label="收票地址">
                    <span>{{ orderInfo.orderRecvInfo.receiverAddress }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div v-if="!hasSubOrder" class="section">
          <div class="section-title">订单明细</div>
          <div class="order-detail-wrapper">
            <OrderItemList :detail-list="orderInfo.detailList" :base-info="orderInfo.baseInfo" @evalutionFormShow="evalutionFormShow" @evalutionInfoShow="evalutionInfoShow" @evalutionFormUpdate="evalutionFormUpdate"/>
          </div>
        </div>

        <div v-else class="section">
          <div class="section-title">子订单详情</div>
          <div class="sub-order-wrapper">
            <div v-for="subOrder in orderInfo.subOrderList" :key="subOrder.orderId">
              <el-row class="sub-info">
                <el-col :span="21" class="order-data">
                  <span class="order-field">子订单号：{{ subOrder.baseInfo.orderNumber }}</span>
                  <span class="order-field">子订单状态：{{ subOrder.baseInfo.orderStatusName }}</span>
                  <span v-if="!orderInfo.baseInfo.isPreOrder" class="order-field">子订单金额：<span class="order-amount">￥{{ subOrder.baseInfo.orderAmount }}元</span></span>
                  <span v-if="orderInfo.baseInfo.isPreOrder" class="order-field">定金金额：<span class="order-amount">￥{{ subOrder.baseInfo.earnestAmount }}元</span></span>
                  <span v-if="orderInfo.baseInfo.isPreOrder" class="order-field">尾款金额：<span class="order-amount">￥{{ subOrder.baseInfo.orderAmount || 0 }}元</span></span>
                  <span class="order-field">已支付金额：<span class="order-amount">￥{{ subOrder.baseInfo.paidAmount }}元</span></span>
                </el-col>
                <el-col :span="3" class="order-opt">
                  <!-- <el-button v-if="hasSubLogistics(subOrder)" type="text" @click="viewLogisticsInfo(subOrder.baseInfo)">物流详情</el-button> -->
                </el-col>
              </el-row>
              <OrderItemList :detail-list="subOrder.detailList" :base-info="subOrder.baseInfo" @evalutionFormShow="evalutionFormShow" @evalutionInfoShow="evalutionInfoShow" @evalutionFormUpdate="evalutionFormUpdate"/>
            </div>
          </div>
        </div>

      </el-col>
    </el-row>
    <logistics-dialog ref="logistics-dialog"/>

    <!-- 评价弹窗 -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="商品评价" width="34%" class="evalut-form" @close="clearImg">
      <el-form>
        <el-form-item>
          <img :src="getImageUrl(item.itemImageUri)" class="order-img">
          <span style="vertical-align: middle">{{ item.name }}</span>
        </el-form-item>
        <el-form-item label="描述" required>
          <el-rate
            v-model="comment.itemScore"
            :colors="['#909399', '#F87500', '#FF000A']"
            show-text
            style="margin-top: 9px"/>
          <el-input v-model="comment.itemComment" :rows="3" type="textarea" placeholder="请输入评价内容"/>
        </el-form-item>
        <el-form-item label="上传">
          <el-upload 
            ref="upload"
            :action="fileUploadTarget"
            :on-success="handleImgSuccess"
            :on-error="handleImgFailed"
            :before-remove="confirmImgRemove"
            :on-exceed="handleExceed"
            :limit="5"
            :accept="'image/*'"
            :file-list="commentImg"
            list-type="picture-card"
            multiple>
            <i class="el-icon-plus"/>
          </el-upload>
          <span class="img-amount">({{ selectedImgs }}/5)</span>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isAnonymity">匿名</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" class="btn-red" @click="submitComment">提交</el-button>
      </div>
    </el-dialog>

    <!-- 查看商品评价 -->
    <el-dialog :visible.sync="dialogInfoVisible" :close-on-click-modal="false" title="查看商品评价" width="34%" class="evalut-form" @close="clearShow">
      <el-form>
        <el-form-item>
          <img :src="getImageUrl(item.itemImageUri)" class="order-img">
          <span style="vertical-align: middle">{{ item.name }}</span>
        </el-form-item>
        <el-form-item label="描述">
          <el-rate
            v-model="comment.itemScore"
            :colors="['#909399', '#F87500', '#FF000A']"
            show-text
            style="margin-top: 9px" 
            disabled/>
        </el-form-item>
        <p>{{ comment.itemComment }}</p>
        <el-form-item>
          <div v-for="(item, index) in comment.itemCommentImageList" :key="item.id" class="comment-img">
            <img :src="getImageUrl(item.imageFileUri)" @click="showImgDetail(comment.itemCommentImageList, index)">
          </div>
        </el-form-item>
        <div>{{ comment.createDate | parseTime('{y}-{m}-{d}') }}</div>
      </el-form>
    </el-dialog>

    <!-- 查看图片大图 -->
    <el-dialog :visible.sync="dialogImageVisible" title="查看评论图片">
      <div class="preview_pic">
        <img :src="showImage" class="preview_pic_show center">
      </div>
      <div class="text-center">
        <img 
          v-for="(item, index) in imageList"
          :class="[{ picActive: index === curIndex }, 'preview_pic_small']"
          :src="getImageUrl(item.imageFileUri)"
          :alt="item.imageName"
          :key="item.imageId"
          @click="switchShowImg(index)">
      </div>
    </el-dialog>

    <!-- 查看物流进度弹框 -->
    <el-dialog :visible.sync="sfProgressOption.visible" title="查看物流进度" width="700px" @closed="sfProgressOption.dataMap = []">
      <div v-if="checkItem" class="el-dialog__body_box">
        <div v-for="(item, index) in sfProgressOption.dataMap" :key="index">
          <div v-if="item.length">
            <div class="danhao"><b> 运单号 : {{ item[0].logisticsNumber }}</b></div>
            <el-timeline>
              <el-timeline-item v-for="(bill, index) in item" :color="`#cd1231`" :timestamp="(bill.locationTime).toString()" :key="index" hide-timestamp>
                <span>{{ bill.locationTime | parseTime('{y}-{m}-{d}') }}</span> 
                <span class="small">{{ bill.locationTime | parseTime('{h}:{i}:{s}') }}</span>
                <span>{{ bill.locationDesc }}</span> 
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <template v-else>
        {{ sfProgressOption.hasInfo }}
      </template>
    </el-dialog>
  </div>
</template>

<script>
import orderApi from "@/api/order";
import baseApi from "@/api/base";
import itemApi from "@/api/item";
import { mapGetters } from "vuex";
import { commonUtils } from "@/utils/common";
import UserMenu from "../user/components/user-menu";
import OrderItemList from "./components/order-item-list";
import logisticsDialog from "./components/logistics-dialog.vue";
let isCreate = Boolean;
export default {
  name: "OrderInfo",
  components: {
    UserMenu,
    OrderItemList,
    "logistics-dialog": logisticsDialog
  },
  data() {
    return {
      orderInfo: {
        baseInfo: {},
        orderRecvInfo: {},
        detailList: [],
        subOrderList: []
      },
      showLogisticsTrack:'',
      loading: false,
      dialogVisible: false,
      dialogInfoVisible: false,
      item: {
        itemImageUri: "",
        name: ""
      },
      comment: {
        orderId: "",
        orderDetailId: "",
        isAnonymity: 0,
        itemId: "",
        itemScore: 0,
        itemComment: "",
        itemCommentImageList: []
      },
      isAnonymity: false,
      selectedImgs: 0,
      submitLoading: false,
      dialogImageVisible: false,
      showImage: "",
      curIndex: 0,
      imageList: [],
      commentImg: [],
      sfProgressOption: {
        dataMap: [],
        hasInfo: '暂无物流进度',
        visible: false,
      },
    };
  },
  computed: {
    checkItem() {
      if(this.sfProgressOption.dataMap.length){
          for (let i = 0; i < this.sfProgressOption.dataMap.length; i++) {
            if (this.sfProgressOption.dataMap[i].length > 0) {
               return true;
            }
        }
      }
         return false;
    },
    isAssetOrder() {
      return this.orderInfo.baseInfo.orderType === "02";
    },
    isPackageOrder() {
      return this.orderInfo.baseInfo.orderType === "03";
    },
    needPay() {
      return (
        this.orderInfo.baseInfo.orderStatus === 100 ||
        this.orderInfo.baseInfo.orderStatus === 50
      );
    },
    showOrderAmount() {
      return this.orderInfo.baseInfo.isPreOrder
        ? this.orderInfo.baseInfo.earnestAmount || 0
        : this.orderInfo.baseInfo.orderAmount || 0;
    },
    showDiscountAmount() {
      return this.orderInfo.baseInfo.discountAmount >
        this.orderInfo.baseInfo.totalAmount
        ? this.orderInfo.baseInfo.totalAmount
        : this.orderInfo.baseInfo.discountAmount;
    },
    hasSubOrder() {
      return (
        this.orderInfo.subOrderList && this.orderInfo.subOrderList.length > 0
      );
    },
    hasMainLogistics() {
      return (
        this.orderInfo.baseInfo.orderStatus === 400 ||
        this.orderInfo.baseInfo.orderStatus === 500
      );
    },
    canCancel() {
      // 不可预售商品-待支付 && 预售商品-待付定金  可以  取消订单
      return (
        (!this.orderInfo.baseInfo.isPreOrder &&
          this.orderInfo.baseInfo.orderStatus === 100) ||
        this.orderInfo.baseInfo.orderStatus === 50
      );
    },
    isVatInvoice() {
      return this.orderInfo.orderRecvInfo.invoiceType === "02";
    },
    showPayInfo() {
      let payInfo = this.orderInfo.baseInfo.payTypeName;
      if (this.orderInfo.baseInfo.payType === "01") {
        if (this.orderInfo.baseInfo.payChannel === "alipay") {
          payInfo += " - 支付宝支付";
        }
        if (this.orderInfo.baseInfo.payChannel === "wxpay") {
          payInfo += " - 微信支付";
        }
        if (this.orderInfo.baseInfo.payChannel === "chinapayb2c") {
          payInfo += " - 银联支付-对私";
        }
        if (this.orderInfo.baseInfo.payChannel === "chinapayb2b") {
          payInfo += " - 银联支付-对公";
        }
      }
      return payInfo;
    },
    maskMobileNo() {
      return commonUtils.maskMobileNo(this.orderInfo.orderRecvInfo.recvPhone);
    },
    combineAddressInfo() {
      const address = this.orderInfo.orderRecvInfo;
      let showInfo = "";
      showInfo += address.recvProvinceName ? address.recvProvinceName : "";
      showInfo += address.recvCityName ? ", " + address.recvCityName : "";
      showInfo += address.recvCounty ? ", " + address.recvCounty : "";
      showInfo += address.recvAddress ? ", " + address.recvAddress : "";
      return showInfo;
    },
    invoiceTypeName() {
      return this.orderInfo.orderRecvInfo.invoiceType === "01"
        ? "增值税普通发票"
        : this.orderInfo.orderRecvInfo.invoiceType === "02"
          ? "增值税专用发票"
          : "";
    },
    ...mapGetters(["fileUploadTarget", "fileDeleteTarget", "userInfo"]),
    canOperate() {
      if (this.userInfo) {
        return this.userInfo.clientId === this.orderInfo.baseInfo.clientId;
      }
      return false;
    }
  },
  mounted() {
    this.queryOrderInfo();
  },
  methods: {
    queryOrderInfo() {
      this.orderNumber = this.$route.params.orderNumber;
      if (!this.orderNumber) {
        this.$router.push("/user/order/list");
        return;
      }
      this.loading = true;
      orderApi
        .queryOrderInfoByNumber(this.orderNumber)
        .then(response => {
          this.loading = false;
          if (response.data.resultCode === "0") {
            const orderInfo = response.data.resultData.orderInfo;
            this.showLogisticsTrack = response.data.resultData.showLogisticsTrack || ''
            if (orderInfo) {
              this.orderInfo = Object.assign(this.orderInfo, orderInfo);
            } else {
              this.$message.error("订单信息异常");
              this.$router.push("/user/order/list");
            }
          } else {
            this.$router.push("/user/order/list");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$router.push("/user/order/list");
        });
    },
    cancelOrder() {
      this.$confirm("是否确认取消订单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        type: "warning"
      })
        .then(() => {
          const orderData = {
            orderId: this.orderInfo.baseInfo.orderId
          };
          orderApi.cancelOrder(orderData).then(response => {
            if (response.data.resultCode === "0") {
              this.queryOrderInfo();
            }
          });
        })
        .catch(() => {
          console.log("cancel opt");
        });
    },
    hasSubLogistics(subOrder) {
      return (
        subOrder.baseInfo.orderStatus === 400 ||
        subOrder.baseInfo.orderStatus === 500
      );
    },
    viewLogisticsInfo(baseInfo) {
      this.$refs["logistics-dialog"].showDialog(baseInfo);
    },
    watchLogisticsInfo(){
      this.sfProgressOption.visible = true
      let params = {
            // srcNumber: 'P230202300'
            srcNumber: this.orderNumber
        }
      orderApi
        .getAllLogisticsTrack(params)
        .then(response => {
          if (response.data.resultCode === "0") {
          const { dataMap } = response.data.resultData
          let hasOwnProperty = Object.prototype.hasOwnProperty;
          for (const key in dataMap) {
              if (hasOwnProperty.call(dataMap, key)) {
                  const element = dataMap[key];
                  this.sfProgressOption.dataMap.push(element)
              }
           }
          this.sfProgressOption.dataMap = this.sfProgressOption.dataMap.reverse()
          }})
    },

    evalutionFormShow(data) {
      this.resetComment();
      this.comment.orderId = data.orderId;
      this.comment.orderDetailId = data.detailId;
      this.comment.itemId = data.itemId;
      this.item.itemImageUri = data.itemImageUri;
      this.item.name = data.itemName;
      this.dialogVisible = true;
      isCreate = true;
    },
    evalutionInfoShow(data) {
      this.resetComment();
      this.item.itemImageUri = data.itemImageUri;
      this.item.name = data.itemName;
      this.comment.orderDetailId = data.detailId;
      this.getItemComment();
      this.dialogInfoVisible = true;
    },
    evalutionFormUpdate(data) {
      this.resetComment();
      this.item.itemImageUri = data.itemImageUri;
      this.item.name = data.itemName;
      this.comment.orderDetailId = data.detailId;
      this.getItemComment();
      this.dialogVisible = true;
      isCreate = false;
    },

    getImageUrl(imageUri) {
      return commonUtils.getImageUrl(imageUri);
    },

    // 上传图片成功
    handleImgSuccess(response) {
      if (response.resultCode === "0") {
        this.comment.itemCommentImageList.push({
          imageFileId: response.resultData.fileDTO.fileId
        });
        this.selectedImgs++;
      }
    },
    handleImgFailed() {
      this.$message.error({ message: "服务器异常，图片上传失败！" });
    },
    handleExceed() {
      this.$message.error({ message: "最多上传5张图片" });
    },
    // 删除图片
    confirmImgRemove(file) {
      if (file) {
        const fileId = file.response
          ? file.response.resultData.fileDTO.fileId
          : file.imageFileId;
        baseApi.deleteFile({ fileId: fileId }).then(response => {
          if (response.data.resultCode === "0") {
            this.comment.itemCommentImageList.forEach((item, index) => {
              if (item.imageFileId === fileId) {
                this.comment.itemCommentImageList.splice(index, 1);
                this.selectedImgs--;
              }
            });
          }
        });
      }
    },
    // 提交评价
    submitComment() {
      if (!this.comment.itemScore) {
        this.$message.warning({ message: "请评价商品" });
        return;
      }
      this.submitLoading = true;
      this.comment.isAnonymity = Number(this.isAnonymity);
      if (isCreate) {
        itemApi
          .submitItemComment(this.comment)
          .then(response => {
            this.submitLoading = false;
            if (response.data.resultCode === "0") {
              this.dialogVisible = false;
              this.$message.success("商品评价成功");
              this.queryOrderInfo();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        itemApi
          .updateItemComment(this.comment)
          .then(response => {
            this.submitLoading = false;
            if (response.data.resultCode === "0") {
              this.dialogVisible = false;
              this.$message.success("商品重新评价成功");
              this.queryOrderInfo();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    // 获取商品评价
    getItemComment() {
      const params = {
        detailId: this.comment.orderDetailId
      };
      itemApi.getItemComment(params).then(response => {
        if (response.data.resultCode === "0") {
          this.comment = response.data.resultData.itemCommentInfo;
          if (this.comment.itemCommentImageList.length) {
            for (const p of this.comment.itemCommentImageList) {
              let item = this.getImageUrl(p.imageFileUri);
              this.commentImg.push({ url: item, imageFileId: p.imageFileId });
            }
          }
          this.selectedImgs = this.commentImg.length;
          this.isAnonymity = Boolean(this.comment.isAnonymity);
        }
      });
    },
    showImgDetail(img, index) {
      this.curIndex = index;
      this.imageList = img;
      this.dialogImageVisible = true;
      this.showImage = this.getImageUrl(this.imageList[index].imageFileUri);
    },
    switchShowImg(index) {
      for (let i = 0; i < this.imageList.length; i++) {
        if (index === i) {
          this.showImage = this.getImageUrl(this.imageList[i].imageFileUri);
          this.curIndex = index;
        }
      }
    },
    // 清空评价
    resetComment() {
      this.comment = {
        orderId: "",
        orderDetailId: "",
        isAnonymity: false,
        itemId: "",
        itemScore: 0,
        itemComment: "",
        itemCommentImageList: []
      };
      this.isAnonymity = false;
      this.selectedImgs = 0;
      this.commentImg = [];
    },
    clearImg() {
      this.$refs["upload"].clearFiles();
    },
    clearShow() {
      this.comment = {};
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";
::v-deep .el-dialog__body {
    box-sizing: border-box;
}
::v-deep .el-timeline-item{
  margin-left: 2px;
}
.el-dialog__body_box{
    max-height: 400px;
    min-height: 300px;
    overflow-y: auto;
}
// ::-webkit-scrollbar{
//   width:0;
// }
::v-deep .el-timeline-item__tail{
    border-left:2px solid rgb(205, 18, 49) !important;
}
.danhao{
    margin:0px 0px 20px 0;
}
.small{
    font-size: 13px;
    color: #575757;
    margin-left:10px;
    margin-right: 25px;
}
.order-form {
  .el-form-item {
    margin-bottom: 0px;
  }
  /deep/ .el-form-item__label,
  /deep/ .el-form-item__content {
    line-height: 30px;
  }
  /deep/ label {
    font-weight: 700;
  }
  .view-order-detail {
    margin-left: 10px;
  }
  .order-amount {
    font-size: 16px;
    font-weight: bold;
    color: #f60;
  }
  .base-info {
    .el-col {
      min-height: 32px;
    }
  }
  .btn-inline {
    height: 1px;
    line-height: 1px;
    margin-left: 10px;
  }
  .btn-watch-info{
    height: 1px;
    line-height: 1px;
  }
  .pay-link {
    margin: 10px 0 0 10px;
    padding: 5px 15px;
    text-align: center;
    border-radius: 3px;
    background-color: $base-red;
    color: #fff;
    border-color: $base-red;
    &:hover {
      background-color: rgba(225, 0, 19, 0.8);
      color: #fff;
      border-color: $base-red;
    }
  }
}
.order-detail-wrapper {
  margin-top: -11px;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.sub-order-wrapper {
  margin-top: -11px;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;

  .sub-info {
    height: 40px;
    line-height: 40px;
    background-color: #eee;
    margin-top: 0;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    // font-size: 12px;
    .order-data {
      height: 40px;
      line-height: 40px;
      padding: 0;

      .order-field {
        margin-right: 20px;
      }
      .order-amount {
        font-weight: bold;
        color: #f60;
      }
    }
  }
}
.order-img {
  max-width: 100px;
  max-height: 100px;
  margin-right: 15px;
  vertical-align: middle;
}
.img-amount {
  position: absolute;
  top: 20px;
  left: 1px;
  font-size: 12px;
  color: #909399;
}
.comment-img {
  display: inline-block;
  height: 100px;
  width: 100px;
  margin-right: 10px;
  img {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
}
p {
  margin-top: 0;
}
.preview_pic {
  position: relative;
  height: 300px;
  text-align: center;
  margin-bottom: 20px;
  overflow: hidden;
}
.preview_pic_show {
  max-height: 300px;
}
.preview_pic_small {
  width: 80px;
  height: 80px;
  border: 1px solid #fff;
  cursor: pointer;
  margin: 0 4px 0px 0;
}
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.text-center {
  text-align: center;
}
.picActive {
  border: 2px solid #f87500;
}
</style>
